import { QueryClient } from '@tanstack/react-query'

const ONE_SECOND = 1000
const ONE_MINUTE = ONE_SECOND * 60
const STALE_MINUTES = 5
const GC_MINUTES = 10

const QUERY_CONFIG = {
  STALE_TIME: ONE_MINUTE * STALE_MINUTES,
  GC_TIME: ONE_MINUTE * GC_MINUTES,
  RETRY_COUNT: 1,
} as const

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_CONFIG.STALE_TIME,
      gcTime: QUERY_CONFIG.GC_TIME,
      retry: QUERY_CONFIG.RETRY_COUNT,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
